export const TAG_COLORS = ['slate', 'gray', 'zinc', 'neutral', 'stone', 'red', 'orange', 'amber', 'yellow', 'lime', 'green', 'emerald', 'teal', 'cyan', 'sky', 'blue', 'indigo', 'violet', 'purple', 'fuchsia', 'pink', 'rose'] as const;
export type TagColor = typeof TAG_COLORS[number];
export type TagState = 'none' | 'success' | 'warning' | 'critical' | 'info' | 'availabilityHighWarning' | "availabilityLowWarning" | TagColor;

export const toColor = (state: TagState): TagColor => {

    if (state === 'success') return 'emerald';
    if (state === 'warning') return 'amber';
    if (state === 'critical') return 'rose';
    if (state === 'info') return 'blue';
    if (state === 'availabilityHighWarning') return 'amber';
    if (state === 'availabilityLowWarning') return 'emerald';
    if (state === 'none') return 'slate';

    if ((TAG_COLORS as readonly string[]).includes(state)) {
        return state as TagColor;
    }

    return 'slate';
}